export const PARSE_NEWSLETTER_TOKEN_REQUEST = 'token/PARSE_NEWSLETTER_TOKEN_REQUEST';
export const PARSE_NEWSLETTER_TOKEN_SUCCESS = 'token/PARSE_NEWSLETTER_TOKEN_SUCCESS';
export const PARSE_NEWSLETTER_TOKEN_FAILURE = 'token/PARSE_NEWSLETTER_TOKEN_FAILURE';

export const CLEAR_GUARDIAN_CONTACT_NEWSLETTER = 'token/CLEAR_GUARDIAN_CONTACT_NEWSLETTER';

export const parseNewsletterTokenRequest = (payload = {}) => ({
  type: PARSE_NEWSLETTER_TOKEN_REQUEST,
  payload,
});
export const parseNewsletterTokenSuccess = (payload = {}) => ({
  type: PARSE_NEWSLETTER_TOKEN_SUCCESS,
  payload,
});
export const parseNewsletterTokenFailure = (payload = {}) => ({
  type: PARSE_NEWSLETTER_TOKEN_FAILURE,
  payload,
});

export const clearGuardianContactNewsletter = (payload = {}) => ({
  type: CLEAR_GUARDIAN_CONTACT_NEWSLETTER,
  payload,
});
